<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Content',
              modelPath: [this, 'form', 'content'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
